import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge has to be taught the custom scale in `tailwind.config.js`,
 * or it guesses. Without this, `text-body` (a font size) and `text-kf-body`
 * (a colour) look like the same class group and the first one is silently
 * dropped — a subtle, hard-to-spot typography bug across the whole app.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["h1", "h2", "h3", "h4", "eyebrow", "body", "small"] },
      ],
      tracking: [{ tracking: ["brand", "wide2", "logo"] }],
    },
  },
});

/** Conditional class names, with later Tailwind utilities winning conflicts. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
